import { useState, useEffect } from "react";
import SliderPage from "./SliderPage";
import home from "../../../Images/homeLite.jpg";
import realEstate from "../../../Images/realEstateImage.jpg";
// import realEstate from "../../../Images/realEstate2.jpg";
// import access from "../../../Images/customer.jpg";
import access from "../../../Images/access&identityImage.jpg";
// import cloudComputing from "../../../Images/cloudComputing.jpg";
import cloudComputing from "../../../Images/cloudComputing1.jpg";
import thirdPartyApiIintegration from "../../../Images/thirdPartyApiIintegration.jpg";
import digitalService from "../../../Images/Digital-transformation-services1.jpg";
import applicationFramework from "../../../Images/ApplicationFrame.jpg";
import styled from "styled-components";
import tw from "twin.macro";

export default function Slider() {
  let [current, setCurrent] = useState(0);
  let [shuffledata, setShuffleData] = useState([]);

  let goToNext = () => {
    if (current === slides.length - 1) setCurrent(0);
    else setCurrent(current + 1);
  };

  useEffect(() => {
    const intervalId = setInterval(goToNext, 10000); // Change 5000 to adjust interval time (in milliseconds)
    return () => clearInterval(intervalId);
  }, [current]);

  let slidesData = [
    {
      image: home,
      typeID: "e1",
      typedHead: "Bespoke software development company",
      heading1: "Hire the best",
      heading2: "Development Team.",
      route: "/",
      routeState: "contact",
      buttonName: "Hire Us",
    },
    {
      image: realEstate,
      typeID: "e2",
      typedHead:
        "We bring our deep expertise of the U.S. real estate market to your advantage.",
      heading1: "Real Estate  ",
      heading2: "Software Development Company",
      route: "/what-we-do/real-estate-software-company",
      routeState: "",
      buttonName: "Read More",
    },
    {
      image: access,
      typeID: "e3",
      typedHead:
        "CIAM streamlines customer authentication and authorization in apps, enhancing registration and login experiences.",
      heading1: "Customer Identity  ",
      heading2: "& Access Management",
      route: "/what-we-do/customer-identity-and-access-management",
      routeState: "",
      buttonName: "Read More",
    },
    {
      image: cloudComputing,
      typeID: "e4",
      typedHead:
        "Increase resiliency and make your business global by benefiting from moving your systems to the cloud.",
      heading1: "Cloud Consulting ",
      heading2: "& Services",
      route: "/what-we-do/cloud-services",
      routeState: "",
      buttonName: "Read More",
    },
    {
      image: thirdPartyApiIintegration,
      typeID: "e5",
      typedHead:
        "Seamlessly incorporate third-party APIs to enhance functionality and connectivity on your webpage.",
      heading1: "Third-Party ",
      heading2: "API Integrations",
      route: "/our-services/third-party-api-integrations",
      routeState: "",
      buttonName: "Read More",
    },
    {
      image: digitalService,
      typeID: "e6",
      typedHead:
        "Leverage new technologies from maps, messaging and other online tools to enhance your business.",
      heading1: "Digital ",
      heading2: "Transformation Services",
      route: "/what-we-do/digital-transformation-services",
      routeState: "",
      buttonName: "Read More",
    },
    {
      image: applicationFramework,
      typeID: "e7",
      typedHead:
        "Get off the ground running with your new enterprise app with our robust framework and repository.",
      heading1: "Application -",
      heading2: "in-a-box",
      route: "/what-we-do/application-framework",
      routeState: "",
      buttonName: "Read More",
    },
  ];

  useEffect(() => {
    var s = slidesData.sort(func);
    function func(a, b) {
      return 0.5 - Math.random();
    }
    setShuffleData(s);
  }, []);

  let slides = shuffledata.map((item,id) => {
    return (
      <div className="w-full" key={id}>
        <SliderPage slidesData={item} />
      </div>
    );
  });
  return (
    <div className="overflow-hidden relative">
      <div
        className={`flex ${
          current !== 0 && "transition-transform ease-out duration-300"
        }  `}
        style={{
          transform: `translateX(-${current * 100}%)`,
        }}
      >
        {slides}
      </div>
      <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
        {slides.map((_, i) => {
          return (
            <div
              onClick={() => {
                setCurrent(i);
              }}
              key={i}
              className={`block h-2 rounded-2xl cursor-pointer transition-all content=['']  ${
                current === i ? "w-8 bg-white" : "w-4 bg-white/50"
              }`}
            ></div>
          );
        })}
      </div>
    </div>
  );
}
